import React from 'react';
import {
  ColumnInformation,
  joinClassNames,
  TableSorterField,
  TableSorterInformation,
} from '@utahdts/dts-react-common';
import TableSorterSortType from '@utahdts/dts-react-common/components/table-sorter/TableSorterSortType';
import TableSorterDirection from '@utahdts/dts-react-common/components/table-sorter/TableSorterDirection';
import Icon from '../../misc/Icon';
import RowActionsPopover from '../../misc/RowActionsPopover';
import { dateTd, textTd } from '../../misc/Shared';

const customTd = (columnInfo, data, editApproval, deleteApproval) => {
  return (
    <td key={joinClassNames(columnInfo.field, data.name)}>
      <RowActionsPopover>
        <ul className="actions">
          <li
            className="actions-item"
            onClick={() => editApproval(true, data, true)}
          >
            {Icon.iconPencil()} Edit Approval
          </li>
          <li className="actions-item" onClick={() => deleteApproval(data)}>
            {Icon.iconTrash()} Delete Approval
          </li>
        </ul>
      </RowActionsPopover>
    </td>
  );
};

const sorters = {
  companyName: new TableSorterField(
    'companyName',
    TableSorterSortType.TEXT,
    TableSorterDirection.ASCENDING,
  ),
  fdaApprovalDate: new TableSorterField(
    'fdaApprovalDate',
    TableSorterSortType.DATE,
    TableSorterDirection.ASCENDING,
  ),
  drugDescription: new TableSorterField(
    'drugDescription',
    TableSorterSortType.TEXT,
    TableSorterDirection.ASCENDING,
  ),
  createdDate: new TableSorterField(
    'createdDate',
    TableSorterSortType.DATE,
    TableSorterDirection.DESCENDING,
  ),
};

const defaultSorters = (firstSorter) =>
  new TableSorterInformation([
    firstSorter,
    ...Object.values(sorters).filter((sorter) => sorter !== firstSorter),
  ]);

export default (editApproval, deleteApproval) => [
  new ColumnInformation({
    title: 'Company Name',
    field: 'companyName',
    tableSorterInformation: defaultSorters(sorters.companyName),
    tdCallback: textTd,
  }),
  new ColumnInformation({
    title: 'Drug Name',
    field: 'drugDescription',
    tableSorterInformation: defaultSorters(sorters.drugDescription),
  }),
  new ColumnInformation({
    title: 'Approval Date',
    field: 'fdaApprovalDate',
    tableSorterInformation: defaultSorters(sorters.fdaApprovalDate),
    tdCallback: (columnInfo, data) => dateTd(columnInfo, data, false),
  }),
  new ColumnInformation({
    title: 'Date Submitted',
    field: 'createdDate',
    tableSorterInformation: defaultSorters(sorters.createdDate),
    tdCallback: (columnInfo, data) => dateTd(columnInfo, data, true),
  }),
  new ColumnInformation({
    title: 'Actions',
    field: 'actions',
    tdCallback: (columnInfo, data) =>
      customTd(columnInfo, data, editApproval, deleteApproval),
    filter: false,
  }),
];
